import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import styles from './styles.module.scss'
import { Navigation, FreeMode, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper-bundle.css';
import { useSelector, useDispatch } from 'react-redux'
import { closeCarousel } from '../../actions/carousel'



const Carousel = () => {
  
  const data = useSelector(state => state.carousel)
  const dispatch = useDispatch()

  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [mainSwiper, setMainSwiper] = useState(null)
  const [currentSlide, setCurrentSlide] = useState(initialSlide)
  
  const images = data?.images
  const initialSlide = data?.initialSlide || 0

  useEffect(() => {
    setCurrentSlide(initialSlide)
  }, [initialSlide])

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!data || !mainSwiper) return

      if (event.key === 'ArrowLeft') {
        event.preventDefault()
        mainSwiper.slidePrev()
      } else if (event.key === 'ArrowRight') {
        event.preventDefault()
        mainSwiper.slideNext()
      }
    }

    if (data) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [data, mainSwiper])

  useEffect(() => {
    if (!mainSwiper) return

    const mainViewElement = mainSwiper.el.closest(`.${styles.mainView}`)
    
    const handleNavigationClick = (e) => {
      const isNavigationButton = e.target.closest('.swiper-button-next, .swiper-button-prev')
      if (isNavigationButton) {
        e.stopPropagation()
      }
    }

    mainViewElement && mainViewElement.addEventListener('click', handleNavigationClick, true)

    return () => {
      mainViewElement && mainViewElement.removeEventListener('click', handleNavigationClick, true)
    }
  }, [mainSwiper])

  const onClose = () => {
    dispatch(closeCarousel())
  }
  
  const onSlideChange = (swiper) => {
    setCurrentSlide(swiper.activeIndex)
  }

  const onWrapClick = (e) => {
    onClose()
  }


  const stopPropagation = e => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <Modal 
      open={data}
      onClose={onClose}
      classNames={{modal: styles.modal, closeIcon: styles.closeIcon}}
    >
      <div className={styles.carouselContainer} onClick={onWrapClick}>
        {/* Индикатор номера изображения */}
        {images && (
          <div className={styles.imageCounter}>
            {currentSlide + 1} / {images.length}
          </div>
        )}
        
        {/* Основной просмотр изображения - 70% высоты */}
        <div className={styles.mainView}>
          <Swiper
            onSwiper={setMainSwiper}
            onSlideChange={onSlideChange}
            initialSlide={initialSlide}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            modules={[FreeMode, Navigation, Thumbs]}
            className={styles.mainSwiper}
          >
            {images?.map((image, index) => (
              <SwiperSlide key={index} >
                <div className={styles.mainImageWrapper}>
                  <img src={image} alt={`Slide ${index + 1}`} onClick={stopPropagation} className={styles.mainImage} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Навигационный Swiper - 30% высоты */}
        <div className={styles.thumbsView}>
          <Swiper
            onSwiper={setThumbsSwiper}
            initialSlide={initialSlide}
            spaceBetween={10}
            slidesPerView={5}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className={styles.thumbsSwiper}
          >
            {images?.map((image, index) => (
              <SwiperSlide key={index} onClick={stopPropagation}>
                <div className={styles.thumbImageWrapper}>
                  <img src={image} alt={`Thumb ${index + 1}`} className={styles.thumbImage} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </Modal>
  )
}

export default Carousel